<div class="card flex-1 d-flex flex-wrap ai-stretch">


  <div *ngFor="let display of displays; trackBy: trackDisplay; let i=index; let even=even; let last=last" class="basis-50 d-flex fd-row ai-center property-padding" [class.border-right]="even"
    [class.border-bottom]="i < displays.length - (even ? 2 : 1)">
    <mat-icon class="property-icon" *ngIf="!!display.displayIcon">{{ display.displayIcon }}</mat-icon>
    <div class="flex-1 d-flex fd-col jc-center ai-center gap-8 text-container">
      <span class="property-name">{{ display.property?.displayName || '?' }}</span>
      <suvo-bi-property class="d-flex jc-center ai-center" [property]="display.property" [item]="item" [control]="display.control"
        [editItemMode]="editItemMode">
      </suvo-bi-property>

    </div>
  </div>


</div>
